<template lang="pug">
	.content-static-pages
		.inside
			p: | Below you will find a list and descriptions of the resources within our site that you may find useful during the Title 24 Compliance process

			router-link.link-resources(to='/faq')
				span(name='faq'): | Frequently Asked Questions

			p: | If you have questions about our site, the title 24 energy compliance requirements, or the filing process, you should start in our FAQ, as there is a good chance that your question is answered there. If it's not,
				a.contextual-link(href='mailto:customer.service@easytitle24.com')
					span: | &nbsp;please email us your question&nbsp;
				| and we will do our best to answer it.

			router-link.link-resources(to='/compliance-wizard')
				span(name='compliance-wizard'): | Title 24 Compliance Wizard

			p: | Unsure whether or not your project is required to file a Title 24 Report ? Our easy-to-use Title 24 Wizard will answer your question. If you are required to file a report, you will be presented with a Cost Estimator at the end of the process to give you an idea of the costs involved in creating a Title 24 Compliance Report for your project.

			a.link-resources(@click="showModal('What_Residential')")
				span(name='residential'): | What you need to know about Title 24 Compliance for Residential New Construction

			p: | The first in our very popular 'Title 24 Need To Know' series. If you are undertaking a new construction project, rather than an addition to an existing building, this is the introduction that you will want to read.

			a.link-resources(@click="showModal('What_Additions')")
				span(name='additions'): | What you need to know about Title 24 Compliance for Residential Additions

			p: | The second installment of our very popular 'Title 24 Need To Know' series. If you are new to California Title 24 Energy Compliance Regulations, and you are undertaking an addition to a heated structure, no matter how humble, you may want to read this first.

			a.link-resources(@click="showModal('What_NonResidential')")
				span(name='non-residential'): | What you need to know about Title 24 Compliance for Commercial Construction

			p: | The Do-it-yourself tools in this site are targeted to the Residential market. Nevertheless, we have experienced Title 24 Energy Consultants on staff who will be able to help you with Title 24 Energy Analysis needs for any project.

			router-link.link-resources(to='/calcerts-reg')
				span(name='calcerts'): | CalCerts Registration Instructions
			p: | Instructions for registering online with HERS provider CalCerts.

			router-link.link-resources(to='/cheers-reg')
				span(name='cheers'): | Cheers Registration Instructions
			p: | Instructions for registering online with HERS provider Cheers

			router-link.link-resources(to='/prices')
				span(name='prices'): | Service and Price Schedule

			p: | You may also want to consult the prices for our other valued-added services, and see for yourself how cost-effective our site is. Combine that with rockstar Customer Service, and you have a great site to get Title 24 Compliance done quickly, accurately, and economically !

			router-link.link-resources(to='/privacy-policy')
				span(name='privacy-policy'): | Privacy Policy

			p: | We hate spam, and you will not get any from this site, nor will we sell your personal information to the highest bidder. Read all the details of our Privacy Policy and rest assured that you are in good hands.

			router-link.link-resources(to='/terms-and-conditions')
				span(name='terms-and-conditions'): | Terms and conditions

			p: | If you are interested in the fine-print, here is where you should go.

			router-link.link-resources(to='/resource-links')
				span(name='resource-links'): | Resource Links

		b-modal(id='modal1' ref="myModalRef" hide-footer size="lg" :title="TitlePop")
				div(v-if="PopState === 'What_Residential'")
					what-Do-You-Need-Residential
				div(v-if="PopState === 'What_Additions'")
					what-Do-You-Need-Additions
				div(v-if="PopState === 'What_NonResidential'")
					what-Do-You-Need-Non-Residential

				//- div(style="width: 100%; display: flex; justify-content:center;")
				//- 	b-button(@click="hideModal" variant="outline-success" style="width: 20%;"): | Close
				.content-btn( style="width: 100%; display: flex; justify-content:center;")
					a(@click="hideModal")
						easyBtn(btnText="Close")

</template>

<script>
import whatDoYouNeedResidential from '@/components/full/pops/residential/whatResidential'
import whatDoYouNeedAdditions from '@/components/full/pops/additions/whatAdditions'
import whatDoYouNeedNonResidential from '@/components/full/pops/nonResidential/whatNonResidential'
import easyBtn from 'Common/components/easy-btn.vue'
export default {
	name: 'resources-content',
	data () {
		return {
			PopState: '',
			TitlePop: 'Title Pop Up'
		}
	},
	components: {
		whatDoYouNeedResidential,
		whatDoYouNeedAdditions,
		whatDoYouNeedNonResidential,
		easyBtn
	},
	methods: {
		showModal (estado) {
			this.PopState = estado
			this.$refs.myModalRef.show()
			this.changeTitle()
		},
		hideModal () {
			this.PopState = ''
			this.$refs.myModalRef.hide()
		},
		changeTitle () {
			switch (this.PopState[0]) {
			case 'W':
				this.TitlePop = ''
				break
			case 'T':
				this.TitlePop = 'Transmittal Form'
				break
			default:
				break
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/resources/content-resources.vue